import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { DebtStatisticApi, FindDebtEntityQuery } from 'api';

export interface DebtStatisticTimeData {
  time: string;
  totalDebt: number;
  totalCustomerDebt: number;
  totalSupplierDebt: number;
}

export interface DebtStatisticValue {
  totalDebt: number;
  totalCustomerDebt: number;
  totalSupplierDebt: number;
  statistic: Array<DebtStatisticTimeData>;
}

export const findDebtEntity = createAsyncThunk(
  'debtStatistic/findDebtEntity',
  async (option: FindDebtEntityQuery, { rejectWithValue }) => {
    try {
      const response = await DebtStatisticApi.findDebtEntity(option);

      return response;
    } catch (error: any) {
      if (!error.response) {
        throw error;
      }

      return rejectWithValue(error.response.data);
    }
  }
);

interface IState {
  data: DebtStatisticValue;
}

const initialState: IState = {
  data: {
    statistic: [],
    totalDebt: 0,
    totalSupplierDebt: 0,
    totalCustomerDebt: 0,
  },
};

const debtStatisticSlice = createSlice({
  name: 'debtStatistic',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(findDebtEntity.fulfilled, (state, action) => {
      const { data } = action.payload;
      state.data = data;
    });
  },
});

const { reducer: debtStatisticReducer } = debtStatisticSlice;

export default debtStatisticReducer;
